import { render, staticRenderFns } from "./Admin_setting.vue?vue&type=template&id=7160cde8&scoped=true"
import script from "./Admin_setting.vue?vue&type=script&setup=true&lang=js"
export * from "./Admin_setting.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Admin_setting.vue?vue&type=style&index=0&id=7160cde8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7160cde8",
  null
  
)

export default component.exports